import {useState,useEffect} from 'react';
import API from "../../api/phx";
import styles from './HeaderPhoneSw.module.scss';

export function HeaderPhoneSw() {
const [content,setContent] = useState('');

useEffect(() => {
  const getContent = () => {
    API.get('/content').then((result) => {
      setContent(result.data)
    });
}
getContent();
} , []);
    return (
      <ul className={styles.contact}>
        <li className={styles.message}>
          <div className={styles.heading}>
            Call <strong>Attraction Tickets Ltd.</strong><em> FREE</em>
            <span className={styles.details}>{content.opening_hours}</span>
          </div>
        </li>
        <li className={styles.phone}>{content.phone}</li>
      </ul>
    )
  }